import ServiceManager from './ServiceManager';
export default function service(id, options = {}) {
  return function serviceRegister(target) {
    ServiceManager.register(id, target, options);
  };
}